import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useStytchB2BClient } from '@stytch/react/b2b'
import { Organization } from '@stytch/vanilla-js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { BaseWorkspace } from 'honeygrid-types'

import { workspacesQueryKey } from './useWorkspaces'

export const useCreateWorkspace = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()
	const stytchClient = useStytchB2BClient()

	return useMutation({
		mutationFn: (workspace: Partial<BaseWorkspace>) =>
			authFetch('workspaces', {
				method: 'POST',
				body: workspace,
			}) as Promise<Organization>,
		onSuccess: (organization) => {
			stytchClient.session.exchange({
				organization_id: organization.organization_id,
				session_duration_minutes: 60 * 24 * 30,
			})
			queryClient.invalidateQueries({ queryKey: workspacesQueryKey() })
		},
	})
}
